export enum EmailSource {
  Hospital = 'Hospital',
  MobileClinic = 'MobileClinic',
  Customer = 'Customer',
  CSR = 'CSR',
}
